/** cohort_care_options.id — 결제·중복 검사·라벨과 공유 */
export const COHORT_CARE_OPTION_IDS = [
  '328aa0f9-63bc-4d9a-8b04-170eb1d80a82',
  'f3692b1c-656d-4768-97de-e1c4d9b50843',
  '7c35e31e-aa91-47a3-910f-acc0f7d52209',
];
